var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h1',[_vm._v("Nicht gefunden")]),_c('a',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("zurück")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"/main"}},[_vm._v("zur Übersicht")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }